<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-Post-2_security-chain-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-Post-2_security-chain-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.34518828451883;"
    data-aspect-ratio="0.345"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-Post-2_security-chain-xs-img"
      class="g-Post-2_security-chain-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/Post-2_security-chain-xs.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai0-1"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:3.2425%;margin-top:-6px;left:57.5392%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:7.2261%;margin-top:-6.1px;left:43.5819%;margin-left:-50px;width:100px;"
    >
      <p class="g-pstyle1">Ali Khamenei</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:8.7951%;margin-top:-6.1px;left:43.5905%;margin-left:-128px;width:256px;"
    >
      <p class="g-pstyle2">Supreme Leader, Commander-in-Chief</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:15.1149%;margin-top:-5.5px;left:33.8022%;margin-left:-60px;width:120px;"
    >
      <p class="g-pstyle3">SECURITY FORCES</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:15.1149%;margin-top:-5.5px;left:76.8867%;margin-left:-85.5px;width:171px;"
    >
      <p class="g-pstyle3">IRANIAN DEFENCE COUNCIL</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-sm g-aiAbs"
      style="top:16.2134%;left:76.918%;margin-left:-16.5152%;width:33.0303%;"
    >
      <p class="g-pstyle4">Established in 2025 by Khamenei</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:22.8031%;margin-top:-6px;left:6.6593%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:26.9872%;margin-top:-6px;left:20.2233%;margin-left:-64px;width:128px;"
    >
      <p class="g-pstyle5">Abdolrahim Mousavi</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:27.5813%;margin-top:-11.7px;left:51.9296%;margin-left:-57.5px;width:115px;"
    >
      <p class="g-pstyle5">Mohammed-Reza</p>
      <p class="g-pstyle5">Gharaei Ashtiani</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:27.1964%;margin-top:-6px;left:93.2598%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:28.4517%;margin-top:-6px;left:20.262%;margin-left:-52px;width:104px;"
    >
      <p class="g-pstyle6">Chief of Staff (1)</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:29.7069%;margin-top:-6px;left:51.8516%;margin-left:-64.5px;width:129px;"
    >
      <p class="g-pstyle6">Deputy Chief of Staff</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:31.2759%;margin-top:-6px;left:79.7021%;margin-left:-47.5px;width:95px;"
    >
      <p class="g-pstyle5">Ali Shamkhani</p>
    </div>
    <div
      id="g-ai0-14"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:32.7404%;margin-top:-6px;left:79.6217%;margin-left:-48.5px;width:97px;"
    >
      <p class="g-pstyle6">Senior Advisor</p>
    </div>
    <div
      id="g-ai0-15"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:38.8596%;margin-top:-5.5px;left:17.3609%;margin-left:-32.5px;width:65px;"
    >
      <p class="g-pstyle3">ARTESH</p>
    </div>
    <div
      id="g-ai0-16"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:39.4872%;margin-top:-12.5px;left:83.0251%;margin-left:-66.5px;width:133px;"
    >
      <p class="g-pstyle7">LAW ENFORCEMENT</p>
      <p class="g-pstyle7">COMMAND</p>
    </div>
    <div
      id="g-ai0-17"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:40.8471%;margin-top:-12.5px;left:17.3264%;margin-left:-46px;width:92px;"
    >
      <p class="g-pstyle8">Iran's General</p>
      <p class="g-pstyle8">Armed Forces</p>
    </div>
    <div
      id="g-ai0-18"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:45.1358%;margin-top:-5.5px;left:51.8405%;margin-left:-24px;width:48px;"
    >
      <p class="g-pstyle3">IRGC</p>
    </div>
    <div
      id="g-ai0-19"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:47.7508%;margin-top:-18.5px;left:51.7208%;margin-left:-72px;width:144px;"
    >
      <p class="g-pstyle8">Islamic Revolutionary</p>
      <p class="g-pstyle8">Guards Corps Iran's Elite</p>
      <p class="g-pstyle8">Armed Forces</p>
    </div>
    <div
      id="g-ai0-20"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:54.1503%;margin-top:-11.7px;left:83.0929%;margin-left:-41.5px;width:83px;"
    >
      <p class="g-pstyle5">Ahmad</p>
      <p class="g-pstyle5">Reza Radan</p>
    </div>
    <div
      id="g-ai0-21"
      class="g-sm g-aiAbs"
      style="top:53.3473%;left:17.3148%;margin-left:-4.697%;width:9.3939%;"
    >
      <p class="g-pstyle9">Amir</p>
      <p class="g-pstyle9">Hatami</p>
    </div>
    <div
      id="g-ai0-22"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:56.0667%;margin-top:-6px;left:82.9821%;margin-left:-47.5px;width:95px;"
    >
      <p class="g-pstyle6">Chief of police</p>
    </div>
    <div
      id="g-ai0-23"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:56.9559%;margin-top:-12.5px;left:17.3538%;margin-left:-67px;width:134px;"
    >
      <p class="g-pstyle10">Commander-in-Chief</p>
      <p class="g-pstyle10">of Iranian army</p>
    </div>
    <div
      id="g-ai0-24"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:59.1002%;margin-top:-6px;left:37.7444%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai0-25"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:63.4599%;margin-top:-11.7px;left:51.4608%;margin-left:-43px;width:86px;"
    >
      <p class="g-pstyle5">Mohammad</p>
      <p class="g-pstyle5">Pakpour</p>
    </div>
    <div
      id="g-ai0-26"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:66.0563%;margin-top:-12.5px;left:51.7202%;margin-left:-82px;width:164px;"
    >
      <p class="g-pstyle10">Commander-in-Chief</p>
      <p class="g-pstyle10">of Revolutionary Guards (2)</p>
    </div>
    <div
      id="g-ai0-27"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:73.5877%;margin-top:-7.5px;left:48.871%;margin-left:-67px;width:134px;"
    >
      <p class="g-pstyle11">Other key figures killed</p>
    </div>
    <div
      id="g-ai0-28"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:77.6149%;margin-top:-6px;left:38.4502%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle0">Killed*</p>
    </div>
    <div
      id="g-ai0-29"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:77.6149%;margin-top:-6px;left:77.8442%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle0">Killed*</p>
    </div>
    <div
      id="g-ai0-30"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:81.2759%;margin-top:-6px;left:63.7679%;margin-left:-60px;width:120px;"
    >
      <p class="g-pstyle5">Mohammad Shirazi</p>
    </div>
    <div
      id="g-ai0-31"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:81.6944%;margin-top:-6px;left:23.6004%;margin-left:-51px;width:102px;"
    >
      <p class="g-pstyle5">Aziz Nasirzadeh</p>
    </div>
    <div
      id="g-ai0-32"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:83.2111%;margin-top:-12.5px;left:63.7524%;margin-left:-51px;width:102px;"
    >
      <p class="g-pstyle10">Head of the</p>
      <p class="g-pstyle10">military bureau</p>
    </div>
    <div
      id="g-ai0-33"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:82.845%;margin-top:-6px;left:23.7059%;margin-left:-55px;width:110px;"
    >
      <p class="g-pstyle6">Defence minister</p>
    </div>
    <div
      id="g-ai0-34"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:88.7027%;margin-top:-6px;left:38.4502%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle0">Killed*</p>
    </div>
    <div
      id="g-ai0-35"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:88.7027%;margin-top:-6px;left:78.4502%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle0">Killed*</p>
    </div>
    <div
      id="g-ai0-36"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:93.4809%;margin-top:-11.7px;left:63.1139%;margin-left:-45.5px;width:91px;"
    >
      <p class="g-pstyle5">Hossein Jabal</p>
      <p class="g-pstyle5">Amelian</p>
    </div>
    <div
      id="g-ai0-37"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:92.9914%;margin-top:-6px;left:23.6805%;margin-left:-40.5px;width:81px;"
    >
      <p class="g-pstyle5">Saleh Asadi</p>
    </div>
    <div
      id="g-ai0-38"
      class="g-sm g-aiAbs"
      style="top:93.6192%;left:23.7467%;margin-left:-22.8788%;width:45.7576%;"
    >
      <p class="g-pstyle12">Military intelligence chief</p>
    </div>
    <div
      id="g-ai0-39"
      class="g-sm g-aiAbs"
      style="top:94.8745%;left:63.7254%;margin-left:-16.5152%;width:33.0303%;"
    >
      <p class="g-pstyle13">
        Head of SPND, Organisation of Defensive Innovation and Research
      </p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-Post-2_security-chain-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.38961038961039;"
    data-aspect-ratio="0.39"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-Post-2_security-chain-sm-img"
      class="g-Post-2_security-chain-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/Post-2_security-chain-sm.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai1-1"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:4.6344%;margin-top:-9.7px;left:57.5663%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:9.0652%;margin-top:-9.7px;left:44.6009%;margin-left:-55.5px;width:111px;"
    >
      <p class="g-pstyle1">Ali Khamenei</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:10.5931%;margin-top:-9.7px;left:44.5714%;margin-left:-144.5px;width:289px;"
    >
      <p class="g-pstyle2">Supreme Leader, Commander-in-Chief</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:17.6151%;margin-top:-8.6px;left:34.5505%;margin-left:-68px;width:136px;"
    >
      <p class="g-pstyle3">SECURITY FORCES</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:17.6151%;margin-top:-8.6px;left:81.6885%;margin-left:-98px;width:196px;"
    >
      <p class="g-pstyle3">IRANIAN DEFENCE COUNCIL</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-sm g-aiAbs"
      style="top:18.7166%;left:81.0853%;margin-left:-12.3529%;width:24.7059%;"
    >
      <p class="g-pstyle4">Established in 2025 by Khamenei</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:26.4831%;margin-top:-9.7px;left:7.3703%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:30.3028%;margin-top:-9.7px;left:94.3107%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:32.6711%;margin-top:-18.7px;left:52.8653%;margin-left:-73px;width:146px;"
    >
      <p class="g-pstyle1">Mohammed-Reza</p>
      <p class="g-pstyle1">Gharaei Ashtiani</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:32.5947%;margin-top:-9.7px;left:20.6291%;margin-left:-81.5px;width:163px;"
    >
      <p class="g-pstyle1">Abdolrahim Mousavi</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:34.0461%;margin-top:-9.7px;left:20.6622%;margin-left:-65.5px;width:131px;"
    >
      <p class="g-pstyle2">Chief of Staff (1)</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:34.8865%;margin-top:-9.7px;left:52.8301%;margin-left:-82.5px;width:165px;"
    >
      <p class="g-pstyle2">Deputy Chief of Staff</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:36.2616%;margin-top:-9.7px;left:81.6203%;margin-left:-59.5px;width:119px;"
    >
      <p class="g-pstyle1">Ali Shamkhani</p>
    </div>
    <div
      id="g-ai1-14"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:37.7895%;margin-top:-9.7px;left:81.6816%;margin-left:-61.5px;width:123px;"
    >
      <p class="g-pstyle2">Senior Advisor</p>
    </div>
    <div
      id="g-ai1-15"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:45.0406%;margin-top:-8.6px;left:53.0339%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle3">IRGC</p>
    </div>
    <div
      id="g-ai1-16"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:45.6517%;margin-top:-16.6px;left:87.5739%;margin-left:-76px;width:152px;"
    >
      <p class="g-pstyle3">LAW ENFORCEMENT</p>
      <p class="g-pstyle3">COMMAND</p>
    </div>
    <div
      id="g-ai1-17"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:45.117%;margin-top:-8.6px;left:15.5957%;margin-left:-36px;width:72px;"
    >
      <p class="g-pstyle3">ARTESH</p>
    </div>
    <div
      id="g-ai1-18"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:47.8672%;margin-top:-24.6px;left:53.0415%;margin-left:-82.5px;width:165px;"
    >
      <p class="g-pstyle5">Islamic Revolutionary</p>
      <p class="g-pstyle5">Guards Corps Iran's Elite</p>
      <p class="g-pstyle5">Armed Forces</p>
    </div>
    <div
      id="g-ai1-19"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:47.3324%;margin-top:-16.6px;left:15.6189%;margin-left:-52px;width:104px;"
    >
      <p class="g-pstyle5">Iran's General</p>
      <p class="g-pstyle5">Armed Forces</p>
    </div>
    <div
      id="g-ai1-20"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:57.3464%;margin-top:-9.7px;left:39.8009%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai1-21"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:62.694%;margin-top:-18.7px;left:52.6511%;margin-left:-53.5px;width:107px;"
    >
      <p class="g-pstyle1">Mohammad</p>
      <p class="g-pstyle1">Pakpour</p>
    </div>
    <div
      id="g-ai1-22"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:62.694%;margin-top:-18.7px;left:89.8483%;margin-left:-51.5px;width:103px;"
    >
      <p class="g-pstyle1">Ahmad</p>
      <p class="g-pstyle1">Reza Radan</p>
    </div>
    <div
      id="g-ai1-23"
      class="g-sm g-aiAbs"
      style="top:61.2681%;left:15.1803%;margin-left:-4.8039%;width:9.6078%;"
    >
      <p class="g-pstyle6">Amir</p>
      <p class="g-pstyle6">Hatami</p>
    </div>
    <div
      id="g-ai1-24"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:65.5969%;margin-top:-18.7px;left:53.035%;margin-left:-106px;width:212px;"
    >
      <p class="g-pstyle2">Commander-in-Chief</p>
      <p class="g-pstyle2">of Revolutionary Guards (2)</p>
    </div>
    <div
      id="g-ai1-25"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:64.9094%;margin-top:-9.7px;left:89.851%;margin-left:-60px;width:120px;"
    >
      <p class="g-pstyle2">Chief of police</p>
    </div>
    <div
      id="g-ai1-26"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:65.5969%;margin-top:-18.7px;left:15.1961%;margin-left:-85.5px;width:171px;"
    >
      <p class="g-pstyle2">Commander-in-Chief</p>
      <p class="g-pstyle2">of Iranian army</p>
    </div>
    <div
      id="g-ai1-27"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:70.83%;margin-top:-10.2px;left:49.9996%;margin-left:-85.5px;width:171px;"
    >
      <p class="g-pstyle7">Other key figures killed</p>
    </div>
    <div
      id="g-ai1-28"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:75.3754%;margin-top:-9.7px;left:40.8337%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle0">Killed*</p>
    </div>
    <div
      id="g-ai1-29"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:75.3754%;margin-top:-9.7px;left:75.0291%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle0">Killed*</p>
    </div>
    <div
      id="g-ai1-30"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:79.8827%;margin-top:-9.7px;left:62.2369%;margin-left:-76.5px;width:153px;"
    >
      <p class="g-pstyle1">Mohammad Shirazi</p>
    </div>
    <div
      id="g-ai1-31"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:80.341%;margin-top:-9.7px;left:27.2766%;margin-left:-64.5px;width:129px;"
    >
      <p class="g-pstyle1">Aziz Nasirzadeh</p>
    </div>
    <div
      id="g-ai1-32"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:82.0981%;margin-top:-18.7px;left:62.2227%;margin-left:-64.5px;width:129px;"
    >
      <p class="g-pstyle2">Head of the</p>
      <p class="g-pstyle2">military bureau</p>
    </div>
    <div
      id="g-ai1-33"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:81.7161%;margin-top:-9.7px;left:27.3017%;margin-left:-69.5px;width:139px;"
    >
      <p class="g-pstyle2">Defence minister</p>
    </div>
    <div
      id="g-ai1-34"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:87.1401%;margin-top:-9.7px;left:40.8337%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle0">Killed*</p>
    </div>
    <div
      id="g-ai1-35"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:87.1401%;margin-top:-9.7px;left:75.0291%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle0">Killed*</p>
    </div>
    <div
      id="g-ai1-36"
      class="g-sm g-aiAbs g-aiPointText"
      style="top:92.7933%;margin-top:-18.7px;left:61.5309%;margin-left:-57px;width:114px;"
    >
      <p class="g-pstyle1">Hossein Jabal</p>
      <p class="g-pstyle1">Amelian</p>
    </div>
    <div
      id="g-ai1-37"
      class="g-sm g-aiAbs"
      style="top:91.4439%;left:27.3458%;margin-left:-7.7451%;width:15.4902%;"
    >
      <p class="g-pstyle6">Saleh Asadi</p>
    </div>
    <div
      id="g-ai1-38"
      class="g-sm g-aiAbs"
      style="top:92.9717%;left:27.3131%;margin-left:-19.7059%;width:39.4118%;"
    >
      <p class="g-pstyle8">Military intelligence chief</p>
    </div>
    <div
      id="g-ai1-39"
      class="g-sm g-aiAbs"
      style="top:94.2704%;left:62.1888%;margin-left:-16.9608%;width:33.9216%;"
    >
      <p class="g-pstyle8">
        Head of SPND, Organisation of Defensive Innovation and Research
      </p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-Post-2_security-chain-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 0.55137844611529;"
    data-aspect-ratio="0.551"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-Post-2_security-chain-md-img"
      class="g-Post-2_security-chain-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/Post-2_security-chain-md.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai2-1"
      class="g-md g-aiAbs g-aiPointText"
      style="top:4.3997%;margin-top:-9.7px;left:48.9953%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-md g-aiAbs g-aiPointText"
      style="top:9.6628%;margin-top:-9.7px;left:38.1528%;margin-left:-55.5px;width:111px;"
    >
      <p class="g-pstyle1">Ali Khamenei</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-md g-aiAbs g-aiPointText"
      style="top:11.3337%;margin-top:-9.7px;left:38.1361%;margin-left:-144.5px;width:289px;"
    >
      <p class="g-pstyle2">Supreme Leader, Commander-in-Chief</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-md g-aiAbs g-aiPointText"
      style="top:19.0126%;margin-top:-8.6px;left:30.3927%;margin-left:-68px;width:136px;"
    >
      <p class="g-pstyle3">SECURITY FORCES</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-md g-aiAbs g-aiPointText"
      style="top:19.0126%;margin-top:-8.6px;left:81.9691%;margin-left:-98px;width:196px;"
    >
      <p class="g-pstyle3">IRANIAN DEFENCE COUNCIL</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-md g-aiAbs"
      style="top:20.2172%;left:81.5029%;margin-left:-9.5455%;width:19.0909%;"
    >
      <p class="g-pstyle4">Established in 2025 by Khamenei</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-md g-aiAbs g-aiPointText"
      style="top:29.2952%;margin-top:-9.7px;left:8.5408%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-md g-aiAbs g-aiPointText"
      style="top:33.9736%;margin-top:-9.7px;left:92.9347%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-md g-aiAbs g-aiPointText"
      style="top:35.4774%;margin-top:-18.7px;left:44.545%;margin-left:-73px;width:146px;"
    >
      <p class="g-pstyle1">Mohammed-Reza</p>
      <p class="g-pstyle1">Gharaei Ashtiani</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-md g-aiAbs g-aiPointText"
      style="top:35.3938%;margin-top:-9.7px;left:19.6353%;margin-left:-81.5px;width:163px;"
    >
      <p class="g-pstyle1">Abdolrahim Mousavi</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-md g-aiAbs g-aiPointText"
      style="top:36.9811%;margin-top:-9.7px;left:19.6609%;margin-left:-65.5px;width:131px;"
    >
      <p class="g-pstyle2">Chief of Staff (1)</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-md g-aiAbs g-aiPointText"
      style="top:37.9001%;margin-top:-9.7px;left:44.5179%;margin-left:-82.5px;width:165px;"
    >
      <p class="g-pstyle2">Deputy Chief of Staff</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-md g-aiAbs g-aiPointText"
      style="top:39.4038%;margin-top:-9.7px;left:81.9164%;margin-left:-59.5px;width:119px;"
    >
      <p class="g-pstyle1">Ali Shamkhani</p>
    </div>
    <div
      id="g-ai2-14"
      class="g-md g-aiAbs g-aiPointText"
      style="top:41.0747%;margin-top:-9.7px;left:81.9638%;margin-left:-61.5px;width:123px;"
    >
      <p class="g-pstyle2">Senior Advisor</p>
    </div>
    <div
      id="g-ai2-15"
      class="g-md g-aiAbs g-aiPointText"
      style="top:49.0043%;margin-top:-8.6px;left:12.6999%;margin-left:-36px;width:72px;"
    >
      <p class="g-pstyle3">ARTESH</p>
    </div>
    <div
      id="g-ai2-16"
      class="g-md g-aiAbs g-aiPointText"
      style="top:49.0878%;margin-top:-8.6px;left:39.9784%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle3">IRGC</p>
    </div>
    <div
      id="g-ai2-17"
      class="g-md g-aiAbs g-aiPointText"
      style="top:49.7561%;margin-top:-16.6px;left:67.2744%;margin-left:-76px;width:152px;"
    >
      <p class="g-pstyle3">LAW ENFORCEMENT</p>
      <p class="g-pstyle3">COMMAND</p>
    </div>
    <div
      id="g-ai2-18"
      class="g-md g-aiAbs g-aiPointText"
      style="top:51.427%;margin-top:-16.6px;left:12.7178%;margin-left:-52px;width:104px;"
    >
      <p class="g-pstyle5">Iran's General</p>
      <p class="g-pstyle5">Armed Forces</p>
    </div>
    <div
      id="g-ai2-19"
      class="g-md g-aiAbs g-aiPointText"
      style="top:52.1789%;margin-top:-24.6px;left:39.9843%;margin-left:-82.5px;width:165px;"
    >
      <p class="g-pstyle5">Islamic Revolutionary</p>
      <p class="g-pstyle5">Guards Corps Iran's Elite</p>
      <p class="g-pstyle5">Armed Forces</p>
    </div>
    <div
      id="g-ai2-20"
      class="g-md g-aiAbs g-aiPointText"
      style="top:63.3805%;margin-top:-9.7px;left:28.8438%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai2-21"
      class="g-md g-aiAbs g-aiPointText"
      style="top:69.5626%;margin-top:-18.7px;left:12.6728%;margin-left:-35.5px;width:71px;"
    >
      <p class="g-pstyle1">Amir</p>
      <p class="g-pstyle1">Hatami</p>
    </div>
    <div
      id="g-ai2-22"
      class="g-md g-aiAbs g-aiPointText"
      style="top:69.5626%;margin-top:-18.7px;left:39.9833%;margin-left:-53.5px;width:107px;"
    >
      <p class="g-pstyle1">Mohammad</p>
      <p class="g-pstyle1">Pakpour</p>
    </div>
    <div
      id="g-ai2-23"
      class="g-md g-aiAbs g-aiPointText"
      style="top:69.5626%;margin-top:-18.7px;left:67.2559%;margin-left:-51.5px;width:103px;"
    >
      <p class="g-pstyle1">Ahmad</p>
      <p class="g-pstyle1">Reza Radan</p>
    </div>
    <div
      id="g-ai2-24"
      class="g-md g-aiAbs g-aiPointText"
      style="top:72.7372%;margin-top:-18.7px;left:12.6827%;margin-left:-85.5px;width:171px;"
    >
      <p class="g-pstyle2">Commander-in-Chief</p>
      <p class="g-pstyle2">of Iranian army</p>
    </div>
    <div
      id="g-ai2-25"
      class="g-md g-aiAbs g-aiPointText"
      style="top:72.7372%;margin-top:-18.7px;left:40.2798%;margin-left:-106px;width:212px;"
    >
      <p class="g-pstyle2">Commander-in-Chief</p>
      <p class="g-pstyle2">of Revolutionary Guards (2)</p>
    </div>
    <div
      id="g-ai2-26"
      class="g-md g-aiAbs g-aiPointText"
      style="top:71.9853%;margin-top:-9.7px;left:67.2579%;margin-left:-60px;width:120px;"
    >
      <p class="g-pstyle2">Chief of police</p>
    </div>
    <div
      id="g-ai2-27"
      class="g-md g-aiAbs g-aiPointText"
      style="top:79.2117%;margin-top:-10.2px;left:48.6739%;margin-left:-85.5px;width:171px;"
    >
      <p class="g-pstyle6">Other key figures killed</p>
    </div>
    <div
      id="g-ai2-28"
      class="g-md g-aiAbs g-aiPointText"
      style="top:85.6027%;margin-top:-9.7px;left:21.2172%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle0">Killed*</p>
    </div>
    <div
      id="g-ai2-29"
      class="g-md g-aiAbs g-aiPointText"
      style="top:85.6027%;margin-top:-9.7px;left:45.005%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle0">Killed*</p>
    </div>
    <div
      id="g-ai2-30"
      class="g-md g-aiAbs g-aiPointText"
      style="top:85.6027%;margin-top:-9.7px;left:70.4365%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle0">Killed*</p>
    </div>
    <div
      id="g-ai2-31"
      class="g-md g-aiAbs g-aiPointText"
      style="top:85.9368%;margin-top:-9.7px;left:95.1565%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle0">Killed*</p>
    </div>
    <div
      id="g-ai2-32"
      class="g-md g-aiAbs g-aiPointText"
      style="top:91.2%;margin-top:-9.7px;left:10.096%;margin-left:-64.5px;width:129px;"
    >
      <p class="g-pstyle1">Aziz Nasirzadeh</p>
    </div>
    <div
      id="g-ai2-33"
      class="g-md g-aiAbs g-aiPointText"
      style="top:91.2%;margin-top:-9.7px;left:33.9432%;margin-left:-76.5px;width:153px;"
    >
      <p class="g-pstyle1">Mohammad Shirazi</p>
    </div>
    <div
      id="g-ai2-34"
      class="g-md g-aiAbs g-aiPointText"
      style="top:91.9519%;margin-top:-18.7px;left:83.5494%;margin-left:-57px;width:114px;"
    >
      <p class="g-pstyle1">Hossein Jabal</p>
      <p class="g-pstyle1">Amelian</p>
    </div>
    <div
      id="g-ai2-35"
      class="g-md g-aiAbs g-aiPointText"
      style="top:91.2%;margin-top:-9.7px;left:59.3688%;margin-left:-50.5px;width:101px;"
    >
      <p class="g-pstyle1">Saleh Asadi</p>
    </div>
    <div
      id="g-ai2-36"
      class="g-md g-aiAbs g-aiPointText"
      style="top:92.7038%;margin-top:-9.7px;left:10.1154%;margin-left:-69.5px;width:139px;"
    >
      <p class="g-pstyle2">Defence minister</p>
    </div>
    <div
      id="g-ai2-37"
      class="g-md g-aiAbs g-aiPointText"
      style="top:93.6227%;margin-top:-18.7px;left:33.9324%;margin-left:-64.5px;width:129px;"
    >
      <p class="g-pstyle2">Head of the</p>
      <p class="g-pstyle2">military bureau</p>
    </div>
    <div
      id="g-ai2-38"
      class="g-md g-aiAbs g-aiPointText"
      style="top:93.6227%;margin-top:-18.7px;left:59.3052%;margin-left:-82px;width:164px;"
    >
      <p class="g-pstyle2">Military intelligence</p>
      <p class="g-pstyle2">chief</p>
    </div>
    <div
      id="g-ai2-39"
      class="g-md g-aiAbs"
      style="top:93.5673%;left:84.0577%;margin-left:-13.1061%;width:26.2121%;"
    >
      <p class="g-pstyle7">
        Head of SPND, Organisation of Defensive Innovation and Research
      </p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-Post-2_security-chain-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 0.98204857444562;"
    data-aspect-ratio="0.982"
    data-min-width="930"
  >
    <div
      id="g-Post-2_security-chain-lg-img"
      class="g-Post-2_security-chain-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/Post-2_security-chain-lg.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai3-1"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:8.0955%;margin-top:-9.7px;left:39.3105%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-lg g-aiAbs"
      style="top:11.6156%;left:81.2903%;width:9.1398%;"
    >
      <p class="g-pstyle1">Other key figures killed</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:14.7481%;margin-top:-9.7px;left:31.4008%;margin-left:-55.5px;width:111px;"
    >
      <p class="g-pstyle2">Ali Khamenei</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:16.86%;margin-top:-9.7px;left:31.389%;margin-left:-144.5px;width:289px;"
    >
      <p class="g-pstyle3">Supreme Leader, Commander-in-Chief</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:23.1958%;margin-top:-9.7px;left:94.3282%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle0">Killed*</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:26.6717%;margin-top:-8.6px;left:25.8936%;margin-left:-68px;width:136px;"
    >
      <p class="g-pstyle4">SECURITY FORCES</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:26.6717%;margin-top:-8.6px;left:62.4962%;margin-left:-98px;width:196px;"
    >
      <p class="g-pstyle4">IRANIAN DEFENCE COUNCIL</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-lg g-aiAbs"
      style="top:28.0887%;left:62.1654%;margin-left:-6.7742%;width:13.5484%;"
    >
      <p class="g-pstyle5">Established in 2025 by Khamenei</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:30.0596%;margin-top:-9.7px;left:86.3264%;margin-left:-64.5px;width:129px;"
    >
      <p class="g-pstyle2">Aziz Nasirzadeh</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:31.6435%;margin-top:-9.7px;left:86.3403%;margin-left:-69.5px;width:139px;"
    >
      <p class="g-pstyle3">Defence minister</p>
    </div>
    <div
      id="g-ai3-11"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:39.5633%;margin-top:-9.7px;left:10.3858%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai3-12"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:41.1472%;margin-top:-9.7px;left:94.2206%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle0">Killed*</p>
    </div>
    <div
      id="g-ai3-13"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:45.4767%;margin-top:-9.7px;left:70.2783%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai3-14"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:47.3774%;margin-top:-18.7px;left:35.9373%;margin-left:-73px;width:146px;"
    >
      <p class="g-pstyle2">Mohammed-Reza</p>
      <p class="g-pstyle2">Gharaei Ashtiani</p>
    </div>
    <div
      id="g-ai3-15"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:47.2718%;margin-top:-9.7px;left:18.2594%;margin-left:-81.5px;width:163px;"
    >
      <p class="g-pstyle2">Abdolrahim Mousavi</p>
    </div>
    <div
      id="g-ai3-16"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:48.011%;margin-top:-9.7px;left:86.3703%;margin-left:-76.5px;width:153px;"
    >
      <p class="g-pstyle2">Mohammad Shirazi</p>
    </div>
    <div
      id="g-ai3-17"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:49.2781%;margin-top:-9.7px;left:18.2775%;margin-left:-65.5px;width:131px;"
    >
      <p class="g-pstyle3">Chief of Staff (1)</p>
    </div>
    <div
      id="g-ai3-18"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:51.0733%;margin-top:-18.7px;left:86.3628%;margin-left:-64.5px;width:129px;"
    >
      <p class="g-pstyle3">Head of the</p>
      <p class="g-pstyle3">military bureau</p>
    </div>
    <div
      id="g-ai3-19"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:50.4397%;margin-top:-9.7px;left:35.918%;margin-left:-82.5px;width:165px;"
    >
      <p class="g-pstyle3">Deputy Chief of Staff</p>
    </div>
    <div
      id="g-ai3-20"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:52.3405%;margin-top:-9.7px;left:62.4588%;margin-left:-59.5px;width:119px;"
    >
      <p class="g-pstyle2">Ali Shamkhani</p>
    </div>
    <div
      id="g-ai3-21"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:54.4524%;margin-top:-9.7px;left:62.4924%;margin-left:-61.5px;width:123px;"
    >
      <p class="g-pstyle3">Senior Advisor</p>
    </div>
    <div
      id="g-ai3-22"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:61.633%;margin-top:-9.7px;left:94.2206%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle0">Killed*</p>
    </div>
    <div
      id="g-ai3-23"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:64.5809%;margin-top:-8.6px;left:13.3375%;margin-left:-36px;width:72px;"
    >
      <p class="g-pstyle4">ARTESH</p>
    </div>
    <div
      id="g-ai3-24"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:64.6865%;margin-top:-8.6px;left:32.6964%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle4">IRGC</p>
    </div>
    <div
      id="g-ai3-25"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:65.5313%;margin-top:-16.6px;left:52.0678%;margin-left:-76px;width:152px;"
    >
      <p class="g-pstyle4">LAW ENFORCEMENT</p>
      <p class="g-pstyle4">COMMAND</p>
    </div>
    <div
      id="g-ai3-26"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:67.6432%;margin-top:-16.6px;left:13.3501%;margin-left:-52px;width:104px;"
    >
      <p class="g-pstyle6">Iran's General</p>
      <p class="g-pstyle6">Armed Forces</p>
    </div>
    <div
      id="g-ai3-27"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:68.5936%;margin-top:-24.6px;left:32.7006%;margin-left:-82.5px;width:165px;"
    >
      <p class="g-pstyle6">Islamic Revolutionary</p>
      <p class="g-pstyle6">Guards Corps Iran's Elite</p>
      <p class="g-pstyle6">Armed Forces</p>
    </div>
    <div
      id="g-ai3-28"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:68.4967%;margin-top:-9.7px;left:86.3645%;margin-left:-50.5px;width:101px;"
    >
      <p class="g-pstyle2">Saleh Asadi</p>
    </div>
    <div
      id="g-ai3-29"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:71.3478%;margin-top:-18.7px;left:86.3193%;margin-left:-82px;width:164px;"
    >
      <p class="g-pstyle3">Military intelligence</p>
      <p class="g-pstyle3">chief</p>
    </div>
    <div
      id="g-ai3-30"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:82.0131%;margin-top:-9.7px;left:94.2206%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle0">Killed*</p>
    </div>
    <div
      id="g-ai3-31"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:82.6467%;margin-top:-9.7px;left:24.6869%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai3-32"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:89.4049%;margin-top:-18.7px;left:86.3596%;margin-left:-57px;width:114px;"
    >
      <p class="g-pstyle2">Hossein Jabal</p>
      <p class="g-pstyle2">Amelian</p>
    </div>
    <div
      id="g-ai3-33"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:90.4608%;margin-top:-18.7px;left:13.3182%;margin-left:-35.5px;width:71px;"
    >
      <p class="g-pstyle2">Amir</p>
      <p class="g-pstyle2">Hatami</p>
    </div>
    <div
      id="g-ai3-34"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:90.4608%;margin-top:-18.7px;left:32.6998%;margin-left:-53.5px;width:107px;"
    >
      <p class="g-pstyle2">Mohammad</p>
      <p class="g-pstyle2">Pakpour</p>
    </div>
    <div
      id="g-ai3-35"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:90.4608%;margin-top:-18.7px;left:52.0546%;margin-left:-51.5px;width:103px;"
    >
      <p class="g-pstyle2">Ahmad</p>
      <p class="g-pstyle2">Reza Radan</p>
    </div>
    <div
      id="g-ai3-36"
      class="g-lg g-aiAbs"
      style="top:91.4467%;left:86.7204%;margin-left:-9.3011%;width:18.6022%;"
    >
      <p class="g-pstyle7">
        Head of SPND, Organisation of Defensive Innovation and Research
      </p>
    </div>
    <div
      id="g-ai3-37"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:94.4735%;margin-top:-18.7px;left:13.3254%;margin-left:-85.5px;width:171px;"
    >
      <p class="g-pstyle3">Commander-in-Chief</p>
      <p class="g-pstyle3">of Iranian army</p>
    </div>
    <div
      id="g-ai3-38"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:94.4735%;margin-top:-18.7px;left:32.9104%;margin-left:-106px;width:212px;"
    >
      <p class="g-pstyle3">Commander-in-Chief</p>
      <p class="g-pstyle3">of Revolutionary Guards (2)</p>
    </div>
    <div
      id="g-ai3-39"
      class="g-lg g-aiAbs g-aiPointText"
      style="top:93.5231%;margin-top:-9.7px;left:52.056%;margin-left:-60px;width:120px;"
    >
      <p class="g-pstyle3">Chief of police</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-03 11:13 -->

<!-- Generated by ai2svelte v0.123.1 - 2026-03-03 11:13 -->
<!-- ai file: Post-2_security-chain.ai -->
<style lang="scss">
  #g-Post-2_security-chain-box {
    container-type: inline-size;
    container-name: g-Post-2_security-chain-box;
  }
  #g-Post-2_security-chain-box,
  #g-Post-2_security-chain-box .g-artboard {
    margin: 0 auto;
  }
  #g-Post-2_security-chain-box p {
    margin: 0;
  }
  #g-Post-2_security-chain-box .g-aiAbs {
    position: absolute;
  }
  #g-Post-2_security-chain-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-Post-2_security-chain-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-Post-2_security-chain-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-Post-2_security-chain-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-Post-2_security-chain-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-Post-2_security-chain-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-Post-2_security-chain-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-Post-2_security-chain-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-Post-2_security-chain-lg {
        display: block !important;
      }
    }
  }
  #g-Post-2_security-chain-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-Post-2_security-chain-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 11px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-Post-2_security-chain-xs .g-pstyle0 {
    font-weight: 500;
    height: 11px;
    padding-bottom: 6px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-Post-2_security-chain-xs .g-pstyle1 {
    font-weight: 400;
    height: 11px;
    padding-bottom: 6px;
    font-size: 14px;
    text-align: center;
  }
  #g-Post-2_security-chain-xs .g-pstyle2 {
    font-weight: 700;
    height: 11px;
    padding-bottom: 6px;
    font-size: 14px;
    text-align: center;
  }
  #g-Post-2_security-chain-xs .g-pstyle3 {
    font-weight: 400;
    line-height: 10px;
    height: 10px;
    padding-bottom: 6px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-Post-2_security-chain-xs .g-pstyle4 {
    font-weight: 300;
    line-height: 12px;
    padding-bottom: 6px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-Post-2_security-chain-xs .g-pstyle5 {
    font-weight: 400;
    height: 11px;
    padding-bottom: 6px;
    text-align: center;
  }
  #g-Post-2_security-chain-xs .g-pstyle6 {
    font-weight: 700;
    height: 11px;
    padding-bottom: 6px;
    text-align: center;
  }
  #g-Post-2_security-chain-xs .g-pstyle7 {
    font-weight: 400;
    line-height: 12px;
    height: 12px;
    padding-bottom: 6px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-Post-2_security-chain-xs .g-pstyle8 {
    font-weight: 300;
    line-height: 12px;
    height: 12px;
    padding-bottom: 6px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-Post-2_security-chain-xs .g-pstyle9 {
    font-weight: 400;
    padding-bottom: 6px;
    text-align: center;
  }
  #g-Post-2_security-chain-xs .g-pstyle10 {
    font-weight: 700;
    line-height: 12px;
    height: 12px;
    padding-bottom: 6px;
    text-align: center;
  }
  #g-Post-2_security-chain-xs .g-pstyle11 {
    font-weight: 300;
    line-height: 14px;
    height: 14px;
    padding-bottom: 6px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-Post-2_security-chain-xs .g-pstyle12 {
    font-weight: 700;
    padding-bottom: 6px;
    text-align: center;
  }
  #g-Post-2_security-chain-xs .g-pstyle13 {
    font-weight: 700;
    line-height: 12px;
    padding-bottom: 6px;
    text-align: center;
  }
  #g-Post-2_security-chain-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-Post-2_security-chain-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-Post-2_security-chain-sm .g-pstyle0 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-Post-2_security-chain-sm .g-pstyle1 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-Post-2_security-chain-sm .g-pstyle2 {
    font-weight: 700;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-Post-2_security-chain-sm .g-pstyle3 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    padding-bottom: 9px;
    font-size: 14px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-Post-2_security-chain-sm .g-pstyle4 {
    font-weight: 300;
    line-height: 16px;
    padding-bottom: 9px;
    font-size: 14px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-Post-2_security-chain-sm .g-pstyle5 {
    font-weight: 300;
    line-height: 16px;
    height: 16px;
    padding-bottom: 9px;
    font-size: 14px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-Post-2_security-chain-sm .g-pstyle6 {
    font-weight: 400;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-Post-2_security-chain-sm .g-pstyle7 {
    font-weight: 300;
    line-height: 19px;
    height: 19px;
    padding-bottom: 9px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-Post-2_security-chain-sm .g-pstyle8 {
    font-weight: 700;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-Post-2_security-chain-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-Post-2_security-chain-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-Post-2_security-chain-md .g-pstyle0 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-Post-2_security-chain-md .g-pstyle1 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-Post-2_security-chain-md .g-pstyle2 {
    font-weight: 700;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-Post-2_security-chain-md .g-pstyle3 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    padding-bottom: 9px;
    font-size: 14px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-Post-2_security-chain-md .g-pstyle4 {
    font-weight: 300;
    line-height: 16px;
    padding-bottom: 9px;
    font-size: 14px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-Post-2_security-chain-md .g-pstyle5 {
    font-weight: 300;
    line-height: 16px;
    height: 16px;
    padding-bottom: 9px;
    font-size: 14px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-Post-2_security-chain-md .g-pstyle6 {
    font-weight: 300;
    line-height: 19px;
    height: 19px;
    padding-bottom: 9px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-Post-2_security-chain-md .g-pstyle7 {
    font-weight: 700;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-Post-2_security-chain-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-Post-2_security-chain-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-Post-2_security-chain-lg .g-pstyle0 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-Post-2_security-chain-lg .g-pstyle1 {
    font-weight: 300;
    line-height: 19px;
    padding-bottom: 9px;
    color: rgb(0, 0, 0);
  }
  #g-Post-2_security-chain-lg .g-pstyle2 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-Post-2_security-chain-lg .g-pstyle3 {
    font-weight: 700;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-Post-2_security-chain-lg .g-pstyle4 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    padding-bottom: 9px;
    font-size: 14px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-Post-2_security-chain-lg .g-pstyle5 {
    font-weight: 300;
    line-height: 16px;
    padding-bottom: 9px;
    font-size: 14px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-Post-2_security-chain-lg .g-pstyle6 {
    font-weight: 300;
    line-height: 16px;
    height: 16px;
    padding-bottom: 9px;
    font-size: 14px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-Post-2_security-chain-lg .g-pstyle7 {
    font-weight: 700;
    padding-bottom: 9px;
    text-align: center;
  }

  /* Custom CSS */
</style>
